import { Prefecture, City } from 'src/models/enum/Address';
import { AddressAdapterInteface } from 'src/adapter/AddressAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export class AddressApiClass {
  adapter: AddressAdapterInteface;
  constructor(adapter: AddressAdapterInteface) {
    this.adapter = adapter;
  }
  async listPrefectures(): Promise<Prefecture[]> {
    try {
      return await this.adapter.listPrefectures();
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async listCitiesPerPrefecture(pref_code: string): Promise<City[]> {
    try {
      return await this.adapter.listCitiesPerPrefecture(pref_code);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
